import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AD_MANAGEMENT_API } from 'configs/api/adManagement';
import { THttpRequestParams } from 'hooks';
import { IAdSection } from 'types/adManagement';
import { ISelectAdSectionProps } from './types';
import { IGenericEntity } from 'components/_input-components/SelectSimpleFetch/types';
import { SelectSimpleFetch } from '../../SelectSimpleFetch/SelectSimpleFetch';

const SelectAdSection: FC<{ vendorId: number; defaultOption?: IGenericEntity<IAdSection> } & ISelectAdSectionProps> = ({
	vendorId,
	defaultOption,
	...props
}) => {
	const { t: tAdManagement } = useTranslation('ad-management');

	// ! memos
	const requestConfig = useCallback(
		(value?: string, params?: THttpRequestParams) => {
			const searchValue = value?.trim() || undefined; // never send an empty string

			return AD_MANAGEMENT_API.adSectionList(vendorId, searchValue, params);
		},
		[vendorId]
	);

	// ! render
	return (
		<SelectSimpleFetch
			requestConfig={requestConfig}
			placeholder={tAdManagement('form.ad_section.placeholder')}
			showSearch
			defaultOptions={defaultOption ? [defaultOption] : undefined}
			{...props}
		/>
	);
};

export default SelectAdSection;
